import React, { forwardRef, useCallback,useEffect, useImperativeHandle, useState } from "react";
import Select from 'react-select';

import { s360ConfigService } from "../Services/S360Config";

import '../InitialForm/InitialFormStyleSheet.css';

function Dropdown(props, ref) {
  const [optionsArray, setOptionsArray] = useState([]);
  let selectedOption = null;

  useEffect(() => {
    if (props?.item?.options) {
      props.item.options.forEach(eachOption => {
        setOptionsArray([...optionsArray, { value: eachOption, label: eachOption }])
      })
    }
  }, [props?.item?.options]);

  const onSelectOption = (idx) => {
    selectedOption = selectedOption.value;
    document.getElementById(idx).style.display = "block";
  }

  const value = useCallback(() => {
    if (!selectedOption) { return {} ; }
    let aValue = {};
    aValue[props.item.label] = selectedOption;
    return aValue;
  }, [props.item.label, selectedOption]);

  const validate = useCallback(() => {
    let formItemDetails = props.item || {};
    let isRequired = formItemDetails.required || formItemDetails.primaryField;
    return !(isRequired && !selectedOption);
  }, [props.item, selectedOption])

  const validationErrorMessage = useCallback(() => {
    return "Please select " + props.item.label.toLowerCase() + ".";
  }, [props.item.label])

  useImperativeHandle(ref, () => {
    return {
      value() {
        return value();
      },
      validate() {
        return validate();
      },
      validationErrorMessage() {
        return validationErrorMessage()
      }
    };
  }, [validate, validationErrorMessage, value]);

  const selectOptionsStyle = {
    control: (provided) => ({
      ...provided,
      boxShadow: 'none',
      borderStyle: 'unset',
      paddingBottom: "0px",
      width: '100% !important',
      overflowY: 'visible !important',
      ...s360ConfigService.config?.customDesign?.initialFormSelectControl,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "13px",
      fontWeight: "bold",
      fontFamily: "lato",
      ...s360ConfigService.config?.customDesign?.initialFormSelectSingleValue,
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: 'hidden',
      paddingLeft: "0px",
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    menuList: base => ({ ...base, paddingBottom: "0px" }),
    indicatorsContainer: (provided) => ({
      ...provided,
      "svg": {
        fill: s360ConfigService.config?.configDetails?.primaryColor ?? 'black',
        paddingBottom: "1px",
      }
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflowY: 'visible !important',
      // fontFamily: "poppins"
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#AAAAAA',
      fontSize: '12px',
      fontFamily: 'lato',
      fontWeight: '500'
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      const color = s360ConfigService.config?.customDesign?.initialFormSelectBackground?.color;
      return {
        ...styles,
        backgroundColor: isDisabled
          ? null
          : isSelected
            ? color
            : isFocused
              ? "rgb(31 23 92 / 13%)"
              : null,
        ':active': {
          ...styles[':active'],
          backgroundColor: null,
        },
        borderBottom: '1px solid #ccc',
        ...s360ConfigService.config?.customDesign?.initialFormSelectBackground
      };
    },
  };

  return (
    <div className="s360-initial-form-textbox-container" style={s360ConfigService.config?.customDesign?.initialFormTextboxContainer} ref={ref}>
      <fieldset style={{ "borderBottom": "1px solid silver", "margin": "6px -1px", "marginTop": "0px" }}>
        <legend id={'lbl' + props.idxx} style={{
          "width": "auto",
          "padding": "2px",
          "marginBottom": "-3px",
          "fontSize": "10px",
          "lineHeight": "inherit",
          "color": "rgb(108, 103, 103)",
          "border": "0",
          "borderBottom": "none",
          "display": "none",
          // "fontFamily": "poppins"
        }}>
          {props.item.label}
        </legend>
        <Select
          className="s360-initial-form-select"
          styles={selectOptionsStyle}
          maxMenuHeight={198}
          menuPortalTarget={document.body}
          options={optionsArray}
          captureMenuScroll={false}
          isSearchable={false}
          onChange={e => onSelectOption('lbl' + props.idxx, e)}
          components={{ IndicatorSeparator: () => null }}
          placeholder={props.item.label}/>
      </fieldset>
    </div>
  );
}

export default forwardRef(Dropdown);
